<template>
    <div id="app">
      <a-config-provider :locale="locale">
        <router-view  v-if="isRouterAlive" />
      </a-config-provider>
    </div>
</template>
<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
    export default {
        provide () {
          return {
            reload: this.reload
          };
        },
        data() {
            return {
                locale: zhCN,
                isRouterAlive: true
            };
        },
        created () {
          this.getAppInfo();
          console.log("process:"+process.env.ECLOUD_GATEWAY_URL)
        },
        methods: {
          getAppInfo(){
            let url = this.apis.system.getAPPInfo;
            this.http.post(url,{
              where: {
                // domain_like: window.location.host
                lmsDomain_like: "gzgl.gzteacher.com"
                // domain_like: 'http://shxy.ts.dev.gdteacher.com'
              }
            },false,false)
            .then((res)=>{
              console.log(res);
              if (res.data[0]){
                let objStr = JSON.stringify(res.data[0]);
                localStorage.setItem(this.constStatic.APP_INFO, objStr);
              } else {
                return false;
              }
            }).catch((err)=> {
              console.log(err);
            });
          },
          reload () {
            this.isRouterAlive = false;
            this.$nextTick(function () {
              this.isRouterAlive = true;
            });
          }
        },
    }
</script>


<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .ant-form-item-control{
    line-height: 37px;
  }
  p{
    margin-bottom: 0;
  }
  .fenye{
    text-align: right;
    margin-top: 20px;
  }
}
/*(1)清除默认样式*/
html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img,input{ margin:0; padding:0; }
ul,li,ol{ list-style:none; }
select, input { vertical-align:middle;}
textarea { resize:none; } /*防止拖动*/
img {border:0; vertical-align:middle; }
/*  去掉图片低测默认的3像素空白缝隙，或者用display：block也可以*/
table { border-collapse:collapse; }
a {text-decoration:none; }

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
